import { MoneyConnectClientAPI } from './axios-service-creator';

export const FundAPI = {
  searchFund: (payload) => MoneyConnectClientAPI.post('/consolidate/fundSearch', payload),
  getFundType: () => MoneyConnectClientAPI.get('/consolidate/fundSearch/master'),
  getFundDetail: (payload) => MoneyConnectClientAPI.post('/consolidate/fundDetail/fund', payload),
  getNavDetailList: (payload) => MoneyConnectClientAPI.post('/consolidate/fundDetail/nav/graph', payload),
  getFactSheet: (payload) => MoneyConnectClientAPI.post('/consolidate/fundDetail/factSheet', payload, { responseType: 'blob' }),
}